/**
 * Asynchronously loads the component for Login
 */

import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const Login = lazyLoad(
    () => import('./index'),
    module => module.Login,
    { fallback: <LoadingSpinner /> },
);
